import { Node } from './node';
export class CustomLabel implements Node {
  private text: string;
  constructor(text: string) {
    this.text = text;
  }
  public toXML(): string {
    return `<label text="${this.text}"></label>`;
  }
}
